import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=448b7723"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports